import { unwrapPayload } from '@/data/shared/unwrap_payload'
import type { Interest } from '@/domain/interests/entities/interest.entity'
import type { InterestDto } from '../dto/interest.dto'

function findInterestArray(data: unknown, depth = 0): unknown[] {
  if (depth > 4 || data == null) return []
  if (Array.isArray(data)) return data

  const o = unwrapPayload(data)
  for (const key of ['items', 'interests', 'data', 'results'] as const) {
    const val = o[key]
    if (Array.isArray(val)) return val
    if (val && typeof val === 'object') {
      const nested = findInterestArray(val, depth + 1)
      if (nested.length > 0) return nested
    }
  }

  return []
}

export function mapInterestDtoToEntity(raw: unknown): Interest {
  const o = unwrapPayload(raw) as InterestDto
  const iconUrl = o.iconUrl ?? o.icon_url
  const imageUrl = o.imageUrl ?? o.image_url
  const url =
    typeof iconUrl === 'string'
      ? iconUrl
      : typeof imageUrl === 'string'
        ? imageUrl
        : undefined
  const statusRaw = o.status
  const status: Interest['status'] =
    statusRaw === 'inactive' || statusRaw === 'INACTIVE' ? 'inactive' : 'active'
  const id = String(o.id ?? o.interestId ?? o.interest_id ?? '')
  return {
    id,
    name: String(o.name ?? ''),
    imageUrl: url,
    icon: typeof o.icon === 'string' ? o.icon : url,
    status,
    createdAt:
      typeof o.createdAt === 'string'
        ? o.createdAt
        : typeof o.created_at === 'string'
          ? o.created_at
          : undefined,
  }
}

export function extractInterestList(data: unknown): Interest[] {
  const rows = findInterestArray(data)
  return rows.map(mapInterestDtoToEntity).filter(i => Boolean(i.id) || Boolean(i.name))
}
